import { render, staticRenderFns } from "./EmailGroupAdd.vue?vue&type=template&id=1215c415&scoped=true&"
import script from "./EmailGroupAdd.vue?vue&type=script&lang=js&"
export * from "./EmailGroupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215c415",
  null
  
)

export default component.exports